if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cartNotification = document.querySelector('cart-notification');
      this.skipCart = this.dataset.skipCart === 'true' || false;
      this.rebuyActive = this.dataset.rebuy === 'true' || false;
      this.submitButton = this.querySelector('[type="submit"]');
      this.config = "";

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {    
      evt.preventDefault();
      if (this.rebuyActive && window.Rebuy && window.Rebuy.SmartCart)
        window.Rebuy.SmartCart.skip_open = true;      
      this.clearCart();
    }

    clearCart() {
      fetch('/cart/clear.js', { method: 'POST' })
        .then(response => response.json())
        .then(() => this.addToCart())
        .catch(error => console.error('Error:', error));
    }

    addToCart(){
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.setSubmitButtonState(true);

      this.config = fetchConfig('javascript');
      this.config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete this.config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.config.body = formData;

      const selling_plan = this.form.querySelector("[name=selling_plan]")?.value;
      if(!selling_plan && this.findActiveUpsell()){

      } else {
        this.addToCartFetch();
      }
    }

    addToCartFetch() {
      fetch(routes.cart_add_url, this.config)
        .then(response => response.json())
        .then(response => this.handleAddToCartResponse(response))
        .catch(error => console.error(error))
        .finally(() => this.setSubmitButtonState(false));
    }

    handleAddToCartResponse(response) {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }

      if (this.skipCart) {
        // commented out by adam because the onward object doesn't exist 2024-04-23
        // window.onwardApp.fixInsuranceAndProceed().then(() => {
          window.location.href = '/checkout';
        // });
      } else {
        if (this.rebuyActive && window.Rebuy && window.Rebuy.SmartCart) {
          if (window.Rebuy.SmartCart.status === 'disabled') {
            console.log("Rebuy Smart Cart Needs to be Enabled");
          } else {
            window.Rebuy.SmartCart.show();
          }
        } else {
          this.cartNotification.renderContents(response);
        }
      }
    }

    findActiveUpsell() {
      const upsells = getJson(document.querySelector('[type="application/json"].variant_upsells').textContent);
      const upsellData = upsells.find((upsell) => upsell.variant_id == this.form.querySelector('[name=id]').value);
      if(!upsellData) return false;
      let activeUpsell = upsellData.upsells.find((upsell) => !upsell.test_id && upsell.available);
      const upsellTest = upsellData.upsells.find((upsell) => 
        upsell.available && upsell.test_id && document.getElementById(upsell.test_id) ? true : false
      )
      if(upsellTest) {
        activeUpsell = upsellTest;
      }
      if(activeUpsell) {
        this.renderUpsell(activeUpsell);
        return activeUpsell;
      } else {
        return false;
      }
    }

    renderUpsell(activeUpsell) {
      const upsellModal = document.querySelector('[data-upsell]');
      const upsellModalContent = upsellModal.querySelector('[data-upsell-content]');
      const upsellParser = new DOMParser();
      let top_copy = "";
      let bottom_copy = "";
      let cta_bottom_label = "";

      if(activeUpsell.top_copy)
        top_copy = upsellParser.parseFromString(activeUpsell.top_copy, 'text/html').body.textContent;

      if(activeUpsell.bottom_copy)
        bottom_copy = upsellParser.parseFromString(activeUpsell.bottom_copy, 'text/html').body.textContent;

      if(activeUpsell.cta_bottom_label)
        cta_bottom_label = upsellParser.parseFromString(activeUpsell.cta_bottom_label, 'text/html').body.textContent;

      upsellModalContent.innerHTML = `
        <h3 class="product-upsell__title">${activeUpsell.title}</h3>
        <div class="product-upsell__top-copy">${top_copy}</div>
        <img class="product-upsell__img" src="${activeUpsell.image}">
        <div class="product-upsell__bottom-copy">${bottom_copy}</div>
        <div class="product-upsell__bottom">
          <div class="product-upsell__cta-wrap">
            <p class="product-upsell__cta button button--full-width button-blue" data-upsell-accept>
              <span class="product-upsell__cta-badge">${activeUpsell.badge_label}</span>
              <span>${activeUpsell.cta_label}</span>
              </p>
            <span class="product-upsell__label">${cta_bottom_label}</span>
          </div>
          <p class="product-upsell__cta-reject" data-upsell-reject>${activeUpsell.rejection_label}</p>
        </div>
      `;
      this.setUpsellListeners(activeUpsell, upsellModal);
      
      // fire a Gtag event for upsell view
      if (window.gtag) {
          const data = {
              'event_category': 'upsell',
              'event_label': activeUpsell.title,
              'value': activeUpsell.test_id
          };
          window.gtag('event', 'upsell_modal_open', data);
      }

      upsellModal.show();
    }

    setUpsellListeners(activeUpsell, upsellModal) {
      upsellModal.querySelector("[data-upsell-accept]").addEventListener('click', () => {
        this.upsellAccepted(activeUpsell);
        upsellModal.hide(true);
      });

      upsellModal.querySelector("[data-upsell-reject]").addEventListener('click', () => {
        this.upsellRejected(activeUpsell);
        upsellModal.hide(true);
      });

      upsellModal.addEventListener('modal:closed', () =>  {
        this.upsellRejected(activeUpsell);
        upsellModal.hide(true);
      })
    }

    upsellAccepted(activeUpsell) {
      const formData = new FormData(this.form);
      formData.set('id', activeUpsell.upsell_id);
      formData.append('properties[_source]', "upsell");
      formData.append('properties[_upsellState]', "accepted");
      if(activeUpsell.test_id)
        formData.append('properties[_testID]', activeUpsell.test_id);
      this.config.body = formData;
      this.skipCart = true;
      this.addToCartFetch();
    }

    upsellRejected(activeUpsell) {
      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      formData.append('properties[_upsellState]', "rejected");
      if(activeUpsell.test_id)
        formData.append('properties[_testID]', activeUpsell.test_id);
      this.config.body = formData;
      this.addToCartFetch();
    }

    setSubmitButtonState(loading) {
      this.submitButton.classList.toggle('loading', loading);
      this.submitButton.setAttribute('aria-disabled', loading);
      this.querySelector('.loading-overlay__spinner').classList.toggle('hidden', !loading);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function getJson(data) {
  try {
    return JSON.parse(data);
  } catch (err) {
    console.error('Error parsing JSON:', err);
    return {};
  }
}